<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.service_location_feature.service_location') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'service-location-create' })"
            >
              {{ $t('addministration.service_location_feature.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="
                $t('addministration.service_location_feature.search')
              "
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.service_location_name_kh }}</td>
          <td>{{ record.service_location_en }}</td>
          <td>{{ record.contact_person }}</td>
          <td>
            {{ record.contact_number1 }}
            {{ record.contact_number2 ? ' / ' + record.contact_number2 : '' }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.address, 30) }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'service-location-edit',
                params: { id: record.service_location_id }
              }"
              v-tooltip="$t('addministration.service_location_feature.edit')"
              class="mr-3"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a
              href="#"
              v-tooltip="$t('addministration.service_location_feature.delete')"
              class="text-danger"
              @click="destroy(record.service_location_id)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'service-location',
  data() {
    return {
      loading: false,
      columns: [
        {
          name: this.$t('addministration.service_location_feature.name_kh'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.service_location_feature.name_en'),
          style: 'width: 15%;'
        },
        {
          name: this.$t(
            'addministration.service_location_feature.contact_person_name'
          ),
          style: 'width: 20%;'
        },
        {
          name: this.$t('addministration.service_location_feature.contact_no'),
          style: 'width: 18%;'
        },
        { name: this.$t('addministration.service_location_feature.address') },
        {
          name: this.$t('addministration.service_location_feature.action'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('serviceLocation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.serviceLocation.search
      },
      set(newValue) {
        this.$store.commit('serviceLocation/SET_SEARCH', newValue)
        this.$store.commit('serviceLocation/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('serviceLocation/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(service_location_id) {
      if (
        await this.$confirmModal.danger(
          this.$t(
            'addministration.service_location_feature.are_you_sure_to_delete'
          )
        )
      ) {
        this.$store
          .dispatch('serviceLocation/delete', service_location_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'service-location-create') {
      this.$store.commit('serviceLocation/RESET_STATE')
    }
    next()
  }
}
</script>
